import React from 'react'
import styles from './Register.module.css'
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useHistory } from 'react-router-dom';
import Shared from '../services/Shared';
import Navbar from './Navbar'
import Pets from '@material-ui/icons/Pets';
import Api from '../services/Api'
import Util from '../../Util'
import Schedule from '../models/Schedule'

const COLUMNS = [
    "ID",
    "Name",
    "Professor",
    "Semester",
    "Days",
    "Start",
    "End"
];

export default function Register({ location }) {

    const searchParams = new URLSearchParams(location.search);
    const courseIdParam = searchParams.get('course') ?? '';
    
    const [courseId, setCourseId] = React.useState(courseIdParam);
    const [classes, setClasses] = React.useState([]);
    const [day, setDay] = React.useState('');
    const [days, setDays] = React.useState([]);
    const [isConfirmOpen, setIsConfirmOpen] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState('');
    const [semester, setSemester] = React.useState('');

    const history = useHistory();

    React.useEffect(() => {
        getClasses();

        Api.getDays(response => {
            setDays(response);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function getClasses() {

        Api.getClassesBy(courseId, semester, day, response => {
            setClasses(response);
        });
    }

    const selects = [
        {
            items: Shared.semesters,
            name: "Semester",
            any: "Any",
            onChange: value => setSemester(value),
            value: semester,
        },
        {
            items: days,
            name: "Days",
            any: "Any",
            onChange: value => setDay(value),
            value: day,
        },
    ]

    const rows = [];
    for (let c of classes) {
        rows.push({
            id: c.id,
            name: c.course.name,
            faculty: c.faculty.name,
            semester: c.semester,
            days: c.days,
            timeSt: Util.toFETime(c.timeSt),
            timeEnd: Util.toFETime(c.timeEnd),
            clss: c
        });
    }

    function onAdd(row) {
        setSelectedRow(row);
        setIsConfirmOpen(true);
    }

    function onClear() {
        setCourseId('');
        setSemester('');
        setDay('');
    }

    function onConfirm() {

        const json = sessionStorage.getItem(Shared.key.user);
        if (json) {
            const user = JSON.parse(json);

            Api.postSchedule(new Schedule(null, user.id, selectedRow.clss), () => {
                if(history) {
                    history.push(Shared.path.schedule + '?semester=' + selectedRow.clss.semester);
                }
            });
        }
    }

    function onConfirmCancel() {
        setIsConfirmOpen(false);
    }

    function onSearch() {
        getClasses();
    }

    return (
        <>
            <Navbar></Navbar>
            <div className={styles.contain}>
                <h1>Register &nbsp; <Pets /> </h1>

                <div>
                    <Accordion className="accordian" data-testid="accordian-id">
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <div className={styles.searchText}>Search</div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className={`${styles.contain} ${styles.accorDetail}`}>
                                <div className={styles.colContain}>
                                    <div className={styles.input}>
                                        <form noValidate autoComplete="off">
                                            <TextField label="Catalog #" variant="filled" onInput={e => setCourseId(e.target.value)} value={courseId || ''} inputProps={{ "data-testid": "course-id" }}/>
                                        </form>
                                    </div>
                                    <div className={styles.or}>-OR-</div>
                                    <div className={styles.selDiv}>
                                        {selects.map(s => {
                                            return (
                                                <div key={s.name}>
                                                    <FormControl variant="filled" className={styles.sel}>
                                                        <InputLabel id={s.name}>{s.name}</InputLabel>
                                                        <Select
                                                            labelId={s.name}
                                                            id="filled"
                                                            value={s.value}
                                                            onChange={e => s.onChange(e.target.value)}
                                                        >
                                                            <MenuItem value="">
                                                                <em>{s.any}</em>
                                                            </MenuItem>
                                                            {s.items.map(s => {
                                                                return <MenuItem key={s} value={s}>{s}</MenuItem>;
                                                            })}
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                                <div className={`${styles.rowContain} ${styles.timeDiv}`}>
                                    <div>
                                        <Button size="large" onClick={onClear}>Clear</Button>
                                    </div>
                                    <div className={styles.marginLeft}>
                                        <Button size="large" onClick={onSearch} data-testid="search-id">Search</Button>
                                    </div>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </div>

                <div className={styles.tableDiv}>
                    <table className={styles.regTable}>
                        <thead>
                            <tr>
                                {COLUMNS.map(c => {
                                    return (
                                        <th className={styles.regTh} key={c}>{c}</th>
                                    )
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map(r => {
                                return (
                                    <tr className={styles.regTr} key={r.id}>
                                        <td>{r.id}</td>
                                        <td>{r.name}</td>
                                        <td>{r.faculty}</td>
                                        <td>{r.semester}</td>
                                        <td>{r.days}</td>
                                        <td>{r.timeSt}</td>
                                        <td>{r.timeEnd}</td>
                                        <td>
                                            <div className={styles.addButton}>
                                                <Button size="large" onClick={e => onAdd(r)}>Add</Button>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>

                <div className={styles.cardsDiv}>
                    {rows.map(r => {
                        return (
                            <div key={r.id} onClick={e => onAdd(r)}>
                                <Paper className={styles.paper} variant="outlined">
                                    <div className={styles.paperBody}>
                                        <div className={styles.paperHead}>
                                            <div className={styles.paperTitle}>{r.name}</div>
                                            <div>{r.id}</div>
                                        </div>
                                        <div className={styles.paperDetails}>
                                            <div>Professor {r.faculty}</div>
                                            <div className={styles.paperTime}>
                                                <div className={styles.paperSemester}>{r.semester}</div>
                                                <div className={styles.daysTimes}>
                                                    <div>{r.days}</div>
                                                    <div className={styles.at}>at</div>
                                                    <div>{r.timeSt} - {r.timeEnd}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Paper>
                            </div>
                        )
                    })}
                </div>

                <Dialog
                    open={isConfirmOpen}
                    onClose={onConfirmCancel}
                    aria-labelledby="title"
                    aria-describedby="desc"
                >
                    <DialogTitle id="title">{"Add class to schedule?"}</DialogTitle>
                    <DialogContent>
                        {selectedRow && (
                            <div>
                                <div>{selectedRow.name}</div>
                                <div className={styles.confirmTime}>
                                    <div className={styles.confirmSemester}>{selectedRow.semester}</div>
                                    <div>{selectedRow.days} at {selectedRow.timeSt} - {selectedRow.timeEnd}</div>
                                </div>
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onConfirmCancel} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={onConfirm} color="primary" autoFocus>
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </>
    )
}